import { render, staticRenderFns } from "./reports-users.vue?vue&type=template&id=2de64228&scoped=true"
import script from "./reports-users.vue?vue&type=script&lang=js"
export * from "./reports-users.vue?vue&type=script&lang=js"
import style0 from "./reports-users.vue?vue&type=style&index=0&id=2de64228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de64228",
  null
  
)

export default component.exports